export enum CommandCategory {
  MISC = 'Misc',
  PATIENT = 'Patient',
  NAVIGATION = 'Navigation',
}

export type CommandCategoryType = (typeof CommandCategory)[keyof typeof CommandCategory];
